var nullthrows = function nullthrows(value) {
  if (value === null || value === undefined) {
    throw new Error('Unexpected null or undefined.');
  }

  return value;
};

export default nullthrows;